
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[infoID]",
      function () {
        return require("private-next-pages/info/[infoID].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[infoID]"])
      });
    }
  